module.exports = __webpack_public_path__ + "static/media/Docker_colour.d2f9653d.svg";